import React, { useEffect } from 'lib/react';
import { EVGrid, EVPaper } from 'lib/components';
import VirtualizedTable from 'commonComponents/virtualizedTable';
import { useDispatch, useSelector } from 'lib/redux';
import {
  FETCH_STATEFARM_DASHBOARD,
  UPDATE_APPLIED_STATEFARM_FILTER,
  UPDATE_LOCAL_STATEFARM_FILTER,
  RESET_STATEFARM_FILTER,
} from 'constants/ActionTypes';
import RetryScreen from 'commonComponents/retry-screen';
import Typography from 'commonComponents/typography';
import isEqual from 'lodash/isEqual';
import StatefarmChartsStyles from './StatefarmChartsStyles';
import { statefarmDashboardColumns, getStatefarmFilteredData } from '../Analytics.utils';
import StatefarmDashboardLoader from './StatefarmDashboardLoader.component';
import StatefarmFilter from './StatefarmFilter.component';

function StatefarmCharts() {
  const classes = StatefarmChartsStyles();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.analyticsDashboard.statefarmDashboardData);
  const loading = useSelector((state) => state.analyticsDashboard.loading.statefarmDashboard);
  const error = useSelector((state) => state.analyticsDashboard.error.statefarmDashboard);
  const stateFarmLocalFilters = useSelector((state) => state.analyticsDashboard.stateFarmLocalFilters);
  const statefarmFilteredData = useSelector((state) => state.analyticsDashboard.statefarmFilteredData);
  const stateFarmAppliedFilters = useSelector((state) => state.analyticsDashboard.stateFarmAppliedFilters);

  const onFilterChange = (key, value) => {
    dispatch({
      type: UPDATE_LOCAL_STATEFARM_FILTER,
      key,
      value,
    });
  };

  const onApplyButtonClick = () => {
    const filteredData = getStatefarmFilteredData(data, stateFarmLocalFilters);
    dispatch({
      type: UPDATE_APPLIED_STATEFARM_FILTER,
      filteredData,
    });
  };

  const onResetButtonClick = () => {
    dispatch({
      type: RESET_STATEFARM_FILTER,
    });
  };

  const isApplyButtonDisabled = isEqual(stateFarmLocalFilters, stateFarmAppliedFilters);

  useEffect(() => {
    dispatch({ type: FETCH_STATEFARM_DASHBOARD });
  }, [dispatch]);

  if (loading) {
    return <StatefarmDashboardLoader />;
  }

  if (error) {
    return (
      <RetryScreen
        handleRetryButtonClick={() => {
          dispatch({ type: FETCH_STATEFARM_DASHBOARD });
        }}
      />
    );
  }

  return (
    <EVGrid className={classes.reportAnalyticsMainContainer} style={{ margin: 0, width: '100%', maxWidth: '100%' }}>
      <EVPaper
        elevation={0}
        className={classes.reportAnalytics}
        style={{
          width: '100%', maxWidth: '100%', margin: 0, padding: '24px',
        }}
      >
        <EVGrid className={classes.downloadExcelButtonContainer}>
          <Typography variant="h3-600" fontColor="charcoal-900">Action Details</Typography>
        </EVGrid>
        <StatefarmFilter
          onApplyButtonClick={onApplyButtonClick}
          onResetButtonClick={onResetButtonClick}
          isApplyButtonDisabled={isApplyButtonDisabled}
          onFilterChange={onFilterChange}
          localFilters={stateFarmLocalFilters}
          filteredDataLength={statefarmFilteredData.length}
          totalDataLength={data.length}
        />
        <EVGrid
          className={classes.tableContainer}
          style={{
            width: '100%', maxWidth: '100%', overflowX: 'auto', margin: 0,
          }}
        >
          <VirtualizedTable
            columns={statefarmDashboardColumns}
            dataList={statefarmFilteredData}
            rowKey="reportId"
            headerProps={{ className: classes.tableHeader }}
            bodyProps={{ className: classes.tableBody }}
            className={classes.table}
            style={{ width: '100%', maxWidth: '100%' }}
          />
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}

export default StatefarmCharts;
